"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mapCategories;
var _createUrlWithNameId = _interopRequireDefault(require("../createUrlWithNameId"));
var _rootCategory = require("../rootCategory");
function mapCategories(response) {
  var mapCategoryData = function mapCategoryData(categoryData) {
    return response.hasOwnProperty("children_data") && categoryData.children_data.map(function (category) {
      var finalUrl = category.special_url ? category.special_url : category.url_path ? category.url_path : (0, _createUrlWithNameId["default"])(category.name, category.id);
      return {
        name: category.name,
        id: category.id,
        parentId: category.parent_id,
        hasSpecialUrl: category.special_url !== null,
        image: {
          altText: category.name,
          originalSrc: category.image && category.image[0].src,
          variants: [{
            name: "natural",
            aspectRatio: category.image && category.image[0].width / category.image[0].height,
            srcset: [{
              url: category.image && category.image[0].src,
              w: category.image && category.image[0].width,
              h: category.image && category.image[0].height
            }]
          }]
        },
        url: (0, _rootCategory.removeRootCategory)(finalUrl),
        subcategories: mapCategoryData(category),
        visibleInMenu: category.include_in_menu
      };
    });
  };
  return mapCategoryData(response);
}